<div class="pago-container">

  <div *ngIf="paySuccess" class="pago-success">
    <h2>Pago exitoso</h2>
    <p>Su cuenta ha sido activada correctamente. Ya puede seguir utilizando el servicio.</p>
    <button (click)="goHome()">Volver al inicio</button>
  </div>

  <div *ngIf="!paySuccess" class="pago-pay-wrapper">
  <div *ngIf="errorMsg" class="pago-error-inline" style="background:#f8d7da;border:1px solid #f5c6cb;color:#721c24;padding:12px;border-radius:8px;margin:16px auto;max-width:640px;text-align:center;">
    <p style="margin:0 0 8px;">{{errorMsg}}</p>
    <button class="btn btn-sm btn-outline-danger" (click)="retry()">Reintentar</button>
  </div>
  <!-- Subscription status banner for renewal -->
  <div *ngIf="accountStatus === 'ACTIVE' && subscriptionExpiresAt" class="subscription-status text-center" style="margin:12px auto;max-width:640px;">
    <p *ngIf="daysUntilExpiry !== null && daysUntilExpiry <= 7" class="text-warning" style="font-weight:bold;">
      Vence en {{daysUntilExpiry}} días — Renovar
      <small class="d-block text-muted">Vence el {{subscriptionExpiresAt | date:'dd/MM/yyyy'}}</small>
    </p>
    <p *ngIf="daysUntilExpiry === null || daysUntilExpiry > 7" class="text-muted">
      Vence el {{subscriptionExpiresAt | date:'dd/MM/yyyy'}}
      <small *ngIf="billingCycleCurrent" class="d-block">Facturación {{billingCycleCurrent}}</small>
    </p>
    <p class="small text-muted">Renovar mismo plan o cambiar plan</p>
  </div>
  <div *ngIf="accountStatus === 'EXPIRED'" class="subscription-status text-center" style="margin:12px auto;max-width:640px;background:#fff3cd;border:1px solid #ffeaa7;padding:12px;border-radius:8px;">
    <p style="margin:0;font-weight:bold;color:#856404;">Período finalizado — Renovar</p>
    <small *ngIf="subscriptionExpiresAt" class="text-muted">Venció el {{subscriptionExpiresAt | date:'dd/MM/yyyy'}}</small>
    <p class="small text-muted" style="margin:4px 0 0;">Seleccione un plan para reactivar su cuenta</p>
  </div>
  <div class="pago-pay">
    <h2>{{pagoTitle}}</h2>
    <p class="text-muted text-center small" style="margin-top:-8px;">Suscripción agnóstica — el total es lo que se cobra</p>
    <div *ngIf="loadingPlans" class="text-center">
      <p>Cargando planes...</p>
    </div>
    <div *ngIf="!loadingPlans && plansLoadError" class="text-center">
      <p class="text-danger">{{plansLoadError}}</p>
      <button (click)="retry()">Reintentar</button>
    </div>
    <div *ngIf="!loadingPlans && !plansLoadError && availablePlans.length === 0" class="text-center">
      <p>No hay planes disponibles</p>
      <button (click)="retry()">Reintentar</button>
    </div>
    <!-- Select step -->
    <div *ngIf="!loadingPlans && !plansLoadError && availablePlans.length > 0 && step==='select'" class="planes-selector">
      <div class="billing-tabs" role="group" aria-label="Elegí el ciclo de facturación">
        <button type="button" class="billing-tab" [class.active]="billingCycle==='mensual'" (click)="switchBillingCycle('mensual')" [attr.aria-pressed]="billingCycle==='mensual'">Mensual</button>
        <button type="button" class="billing-tab" [class.active]="billingCycle==='anual'" (click)="switchBillingCycle('anual')" [attr.aria-pressed]="billingCycle==='anual'">Anual <span class="discount-badge">20% OFF</span></button>
      </div>
      <p class="billing-note" aria-live="polite">{{billingCycle==='anual' ? 'Precio mensual equivalente, con facturación anual por adelantado. Ahorrás un 20%.' : 'Precios por pantalla, con facturación mensual. Podés cancelar cuando quieras.'}}</p>
      <div *ngIf="filteredPlans.length === 0" class="text-center">
        <p>No hay planes para este ciclo</p>
        <p class="small text-muted">Si necesita ayuda, contacte a soporte.</p>
      </div>
      <div *ngIf="filteredPlans.length > 0" class="planes-grid">
        <div *ngFor="let plan of filteredPlans" class="plan-option" [class.popular]="plan.popular" [class.selected]="selectedPlan && selectedPlan.id === plan.id" (click)="selectPlan(plan)">
          <div class="plan-pop" *ngIf="plan.popular">Más elegido</div>
          <div class="plan-name">{{plan.planName || plan.name}}</div>
          <p class="plan-tagline">{{taglineForPlan(plan)}}</p>
          <div class="plan-price"><span class="price-cur">$</span>{{priceDisplay(plan)}} <small>{{plan.currency}} / mes{{(plan.billing || billingCycle)==='anual' ? ' · facturado anual' : ''}}</small></div>
          <div *ngIf="(plan.billing || billingCycle)==='anual'" class="plan-equiv">Facturado anual: <strong>${{annualTotal(plan)}} {{plan.currency}}/año</strong></div>
          <div *ngIf="(plan.billing || billingCycle)!=='anual'" class="plan-trial">Primera semana gratis</div>
          <ul class="plan-feats">
            <li *ngFor="let feat of featuresForPlan(plan)" [class.no]="!feat.included"><span class="feat-ok" *ngIf="feat.included">✓</span><span class="feat-no" *ngIf="!feat.included">✕</span> {{feat.text}}</li>
          </ul>
          <div class="plan-check"><span *ngIf="selectedPlan && selectedPlan.id === plan.id">&#10003; Seleccionado</span><span *ngIf="!selectedPlan || selectedPlan.id !== plan.id">Elegir este plan</span></div>
        </div>
      </div>
      <!-- Provider selector agnostic (hoy solo PayPal, futuro mercadopago) -->
      <div *ngIf="availableProviders.length > 1" class="provider-selector text-center" style="margin-top:16px;">
        <p class="small text-muted">Medio de pago</p>
        <div class="btn-group" role="group">
          <button *ngFor="let prov of availableProviders" type="button" class="btn" [class.btn-primary]="selectedProvider && selectedProvider.id === prov.id" [class.btn-outline-secondary]="!selectedProvider || selectedProvider.id !== prov.id" (click)="selectProvider(prov)">{{prov.name}}</button>
        </div>
      </div>
      <div class="text-center" style="grid-column: 1 / -1; margin-top: 16px;">
        <button class="btn-continuar" [disabled]="!selectedPlan || isLoadingPayPal || (!isNonPayPalProvider && !canRenderPayPal)" (click)="goToConfirm()">
          <span *ngIf="isLoadingPayPal" class="btn-spinner" aria-hidden="true"></span>
          <span>{{isLoadingPayPal ? 'Cargando...' : 'Continuar'}}</span>
        </button>
        <p *ngIf="selectedPlan && !isNonPayPalProvider && !canRenderPayPal" class="small text-warning" style="margin-top:8px;">El pago no está configurado.</p>
        <p *ngIf="isNonPayPalProvider" class="small text-info" style="margin-top:8px;">Método {{selectedProvider.name}} — contactar soporte</p>
      </div>
    </div>
    <!-- Confirm step -->
    <div *ngIf="!loadingPlans && !plansLoadError && step==='confirm'" class="confirm-container">
      <div class="confirm-grid">
        <div class="summary-card">
          <div class="summary-col summary-col-left">
            <div class="summary-plan-name">{{selectedPlan.planName || selectedPlan.name}}</div>
            <div class="summary-plan-billing">{{billingCycle}} · {{selectedPlan.billing}}</div>
            <div class="summary-plan-desc">Facturación {{billingCycle}}</div>
            <div *ngIf="selectedProvider" class="small text-muted">Via {{selectedProvider.name}}</div>
          </div>
          <div class="summary-col summary-col-right">
            <div class="summary-row"><span>Subtotal</span><span>{{amount}} {{currency}}</span></div>
            <div class="summary-row" *ngIf="hasTax"><span>Impuestos</span><span>{{taxAmount}} {{currency}}</span></div>
            <div class="summary-row total"><span>Total</span><strong>{{totalAmount}} {{currency}}<small *ngIf="selectedPlan?.billing==='anual'" style="font-weight:400;font-size:12px;color:#666"> /año</small><small *ngIf="selectedPlan?.billing==='mensual'" style="font-weight:400;font-size:12px;color:#666"> /mes</small></strong></div>
            <p *ngIf="selectedPlan?.billing==='anual'" class="tax-note">Facturado anual</p>
            <p *ngIf="!hasTax && selectedPlan?.billing!=='anual'" class="tax-note">Impuestos incluidos / Sin impuestos adicionales</p>
            <p *ngIf="hasTax && selectedPlan?.billing!=='anual'" class="tax-note">+ impuestos según corresponda</p>
          </div>
        </div>
        <div class="paypal-col" [class.loading]="isLoadingPayPal">
          <div *ngIf="isLoadingPayPal" class="paypal-spinner-overlay" aria-live="polite">
            <span class="btn-spinner"></span>
          </div>
          <div *ngIf="canRenderPayPal" id="paypal-button-container"></div>
          <div *ngIf="isNonPayPalProvider" class="alert alert-info text-center" style="margin:0;">
            <p style="margin:0 0 8px;">Método {{selectedProvider.name}} — contactar soporte</p>
            <small class="text-muted">Este medio estará disponible próximamente.</small>
          </div>
          <p *ngIf="!canRenderPayPal && !isNonPayPalProvider" class="small text-warning text-center">El pago no está configurado.</p>
        </div>
      </div>
    </div>
  </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/pago/pago.component.html